/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PesticidesInputs */

const vi_nav_pesticides = /** @type {(inputs: Nav_PesticidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thuốc bảo vệ thực vật`)
};

/**

* @param {Nav_PesticidesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_pesticides = /** @type {((inputs?: Nav_PesticidesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PesticidesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_pesticides(inputs)
});